/**
 * The store location also carries render data (breadcrumbs, SEO description, categories,
 * adverts, ...). The search (/search/escorts) and URL (/seo/generate-url) endpoints only
 * read these keys, so only they are sent.
 */
const SEARCH_LOCATION_KEYS = [
    'id',
    'slug',
    'is_city',
    'postcode',
    'geo_point',
    'category_id',
    'pathname',
    'locale_name',
    'query',
    'city',
    'county',
    'administrative',
];

export function searchLocationPayload(location) {
    return _.pick(location, SEARCH_LOCATION_KEYS);
}
